import { render, staticRenderFns } from "./SkeletonLeftSidebar.vue?vue&type=template&id=20799713"
import script from "./SkeletonLeftSidebar.vue?vue&type=script&lang=js"
export * from "./SkeletonLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLeftSidebar.vue?vue&type=style&index=0&id=20799713&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports